import { render, staticRenderFns } from "./editor.vue?vue&type=template&id=ab4f8fc8&scoped=true"
import script from "./editor.vue?vue&type=script&lang=ts"
export * from "./editor.vue?vue&type=script&lang=ts"
import style0 from "./editor.vue?vue&type=style&index=0&id=ab4f8fc8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab4f8fc8",
  null
  
)

export default component.exports